import { Button } from '@heidi/design-system/button';
import type { ReactNode } from 'react';

export type RecentsHeaderIconButtonProps = {
  icon: ReactNode;
  ariaLabel: string;
  testId: string;
  onClick?: () => void;
};

/**
 * Shared shape for the Recents header's icon-only actions: the Search
 * trigger and the three-dot filter trigger, in a 28px (`xs` iconOnly) target.
 * Callers pass the icon with `size-4` so it matches the rail's 16px primary
 * nav icons; automatic SVG sizing is off because the legacy `xs` recipe
 * forces `[&_svg]:size-3` over an icon's own size class.
 * Returns a bare `Button` element (not a wrapping component), so it is safe
 * to pass directly as `DropdownMenuTrigger asChild`'s child — Radix clones
 * and forwards ref/props onto whatever element this call produces, exactly
 * as if the `Button` had been written inline.
 */
export const renderRecentsHeaderIconButton = ({
  icon,
  ariaLabel,
  testId,
  onClick,
}: RecentsHeaderIconButtonProps) => (
  <Button
    type="button"
    variant="ghost"
    size="xs"
    iconOnly
    disableAutomaticSvgSizing
    onClick={onClick}
    aria-label={ariaLabel}
    data-testid={testId}
    className="text-text-secondary hover:bg-background-secondary-hover"
  >
    {icon}
  </Button>
);
